import { updateObject } from 'utils/updateObject'
import { SET_2FA, RESET_2FA } from './types'

const initialState = {
  initialized: false,
  enabled: false,
}

const set2FAState = (state, { payload }) =>
  updateObject(state, { ...payload, initialized: true })

const reset2FAState = () => ({ ...initialState })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_2FA:
      return set2FAState(state, action)
    case RESET_2FA:
      return reset2FAState(state, action)
    default:
      return state
  }
}

export default reducer
